import { WebLogo, WebLogoAr } from "@/assets";
import { Link } from "@/i18n/routing";
const Logo = ({
  locale
}) => <Link href="/" className="block" aria-label="site-logo" data-sentry-element="Link" data-sentry-component="Logo" data-sentry-source-file="Logo.jsx">
    {locale === "ar" ? <WebLogoAr /> : <WebLogo />}
  </Link>;
export default Logo;